// extracted by mini-css-extract-plugin
export var divider = "_vd-0";